import { onMounted, onUnmounted, ref, Ref } from "vue";

export const useScrollDrag = (
  isEnable: boolean,
  $scrollContainer: Ref<HTMLElement>,
  $scroll: Ref<HTMLElement>
) => {
  const isDragging = ref(false); // Флаг для скроллинга
  const isDown = ref(false); // Флаг для удержания мыши
  let startX: number;
  let scrollLeft: number;
  let startScrollLeft: number;
  let startY: number;
  let scrollTop: number;
  let startScrollTop: number;
  let dragTimeout: number | null = null; // Таймер для активации скроллинга
  const dragDelay = 200; // Задержка перед началом скроллинга (в миллисекундах)

  const handleMouseDown = (e: MouseEvent) => {
    if (!isEnable) return;
    e.preventDefault();
    isDown.value = false;
    isDragging.value = false;
    startX = e.pageX - $scrollContainer.value!.offsetLeft;
    scrollLeft = $scroll.value?.scrollLeft;
    startScrollLeft = scrollLeft;

    startY = e.pageY - $scrollContainer.value!.offsetTop;
    scrollTop = $scroll.value?.scrollTop;
    startScrollTop = scrollTop;
    
    // Устанавливаем таймер для активации скроллинга
    dragTimeout = window.setTimeout(() => {
      isDown.value = true;
      isDragging.value = true;
      document.body.style.cursor = "grabbing";
    }, dragDelay);
  };

  const handleMouseLeaveOrUp = (event: MouseEvent) => {
    if(!isEnable) return;
    isDown.value = false;

    // Если мышь отпустили до завершения таймера, отменяем таймер
    if (dragTimeout !== null) {
      clearTimeout(dragTimeout);
      dragTimeout = null;
    }

    // Если был скроллинг, устанавливаем isDragging в true
    if (startScrollLeft !== $scroll.value?.scrollLeft || startScrollTop !== $scroll.value?.scrollTop) {
      isDragging.value = true;
    }

    document.body.style.removeProperty("cursor");
    event.preventDefault();
  };

  const handleMouseMove = (e: MouseEvent) => {
    if(!isEnable) return;
    if (!isDown.value || !isDragging.value) return; // Скроллим только после задержки
    const x = e.pageX - $scrollContainer.value!.offsetLeft;
    const y = e.pageY - $scrollContainer.value!.offsetTop;
    const walkX = (x - startX) * 1.15;
    const walkY = (y - startY) * 1.15;
    $scroll.value.scrollLeft = scrollLeft - walkX;
    $scroll.value.scrollTop = scrollTop - walkY;
  };

  const disableDrag = (e: DragEvent) => {
    if(!isEnable) return;
    e.preventDefault(); // Отключаем стандартное поведение перетаскивания
  };

  const handleClick = (e: MouseEvent) => {
    if(!isEnable) return;
    // Если был скроллинг, отменяем клик
    if (isDragging.value) {
      e.preventDefault();
      e.stopPropagation(); // Останавливаем дальнейшее распространение события клика
      isDragging.value = false; // Сбрасываем после предотвращения клика
    }
  };

  onMounted(() => {
    $scrollContainer.value?.addEventListener("mousedown", handleMouseDown);
    $scrollContainer.value?.addEventListener("dragstart", disableDrag); // Отключение перетаскивания
    $scrollContainer.value?.addEventListener("click", handleClick); // Отмена клика при скроллинге
    window.addEventListener("mouseleave", handleMouseLeaveOrUp);
    window.addEventListener("mouseup", handleMouseLeaveOrUp);
    window.addEventListener("mousemove", handleMouseMove);
  });

  onUnmounted(() => {
    $scrollContainer.value?.removeEventListener("mousedown", handleMouseDown);
    $scrollContainer.value?.removeEventListener("dragstart", disableDrag);
    $scrollContainer.value?.removeEventListener("click", handleClick);
    window.removeEventListener("mouseleave", handleMouseLeaveOrUp);
    window.removeEventListener("mouseup", handleMouseLeaveOrUp);
    window.removeEventListener("mousemove", handleMouseMove);
  });

  return {
    isDown,
  };
};
